import React, {useRef, useEffect} from 'react'
import classes from "../style.module.scss"
import useStyles from 'isomorphic-style-loader/useStyles'
import { FormattedMessage, useIntl } from 'react-intl'
import moment from 'moment'
import { Iconfont } from '../../../../../components/icon/iconfont'
import { couponName, expireDate } from '../../../../../../utils/common'
import { useMemo } from 'react'
import { withList } from '../../../../../components/list'
import { GiftCard } from '../../../../../layout/fragments/black-coupon-alert'
import CountDown from "../../../../../components/count-down";
import Cache from "../../../../../../utils/cache";
import {getSensorsUrl} from "../../../../../utils/sensor";
import {useHistory} from "react-router-dom";

export const OptionalCoupon = props => {
    useStyles(classes)
    const { coupon, isExpired, isBest } = props;

    return <div className={`${classes.CouponItem} ${classes.OptionalCoupon} ${isExpired ? classes.CouponItemExpired: ''} ${classes.NoMargin}`}>
        <div className={classes.DiscountCon}>
            <div className={classes.ContentBox}>
                {
                    coupon?.name && <div className={classes.TitleBox}>
                        <p className={classes.ItemTitle}>{coupon.name}</p>
                        {
                            isBest && <div className={classes.TitleBest}>
                                <FormattedMessage id="best_coupon" defaultMessage={'Best Coupon'}/>
                            </div>
                        }
                    </div>
                }

                {
                    coupon?.condition && <p className={classes.Desc1}>
                        <span dangerouslySetInnerHTML={{__html:coupon.condition}}></span>
                    </p>
                }
                {
                    coupon?.description && <p className={classes.Desc2}>
                        <span dangerouslySetInnerHTML={{__html:coupon.description}}></span>
                    </p>
                }

                {
                    coupon?.infoMsg && <p className={classes.Desc2}>
                        <span dangerouslySetInnerHTML={{__html:coupon.infoMsg}}></span>
                    </p>
                }

                {/* {
                    !isExpired && coupon?.willExpires &&
                    <span className={classes.ExpiresMessage}>
                        <FormattedMessage id="expires_soon" defaultMessage="Expires soon" />
                    </span>
                } */}
            </div>
            {/* {
                isExpired &&
                <div className={classes.ExpiredBox}>
                    <FormattedMessage id={"expired"}></FormattedMessage>
                </div>
            } */}
        </div>

        <div className={classes.MeetCon}>
            {
                coupon?.beginDate && coupon?.endDate && <p className={classes.Desc1}>
                    <span className={classes.Dot}>.</span>
                    <span>{moment(coupon?.beginDate).format('DD/MM/YYYY HH:mm')}~{moment(coupon?.endDate).format('DD/MM/YYYY HH:mm')}</span>
                </p>
            }

            {/* {
                coupon?.usageReminder && <p className={classes.Desc2}>
                    <span className={classes.Dot}>.</span>
                    <span>{coupon.usageReminder}</span>
                </p>
            } */}
        </div>
    </div>
}
const CountDownPart = props => {
    useStyles(classes)
    const {date} = props
    const now = Date.now();
    const diff = date - now;
    return <div className={classes.CountDownBox}>
        <span className={classes.Expiresin}><FormattedMessage id="expires_in" defaultMessage="Expires in" /></span>
        <CountDown
            showDay={true}
            showHour={true}
            offset={diff}
            numberClass={classes.numberClass}
        />
        {/*<span className={classes.CountDownText}><FormattedMessage id="ends_today" defaultMessage={"ends today"}/></span>*/}
    </div>
}
export const CouponItem = props =>{
    useStyles(classes)
    const history = useHistory()
    const { coupon, isExpired, isShare, toShare } = props;
    const actualPx = (px) => {
        return (2 * px / 75 * 1) + 'rem'
    }

    return isShare?
    <GiftCard coupon={coupon} toShare={toShare} showShareBtn={true} style={{margin: `0 ${actualPx(10)} ${actualPx(10)}`, boxShadow:'unset'}}/>:
    <div className={`${classes.CouponItem} ${isExpired ? classes.CouponItemExpired: ''}`}>
        <div className={classes.DiscountCon}>
            <div className={classes.ContentBox}>
                {
                    coupon?.name && <p className={classes.ItemTitle}>{coupon.name}</p>
                }

                {
                    coupon?.condition && <p className={classes.Desc1}>
                        <span dangerouslySetInnerHTML={{__html:coupon.condition}}></span>
                    </p>
                }
                {
                    coupon?.description && <p className={classes.Desc2}>
                        <span dangerouslySetInnerHTML={{__html:coupon.description}}></span>
                    </p>
                }

                {
                    /*
                    coupon?.infoMsg && <p className={classes.Desc2}>
                        <span dangerouslySetInnerHTML={{__html:coupon.infoMsg}}></span>
                    </p>
                     */
                }

                {/*
                    !isExpired && coupon?.willExpires && !isShare  &&
                    <span className={classes.ExpiresMessage}>
                        <FormattedMessage id="expires_soon" defaultMessage="Expires soon" />
                    </span>
                    */
                }
            </div>
            {/*
                isExpired && <div className={classes.ExpiredBox}>
                    <FormattedMessage id={"expired"}></FormattedMessage>
                </div>
                */
            }

            {
                isShare &&
                <span className={classes.ShareButton}>
                    <span className={classes.ShareMsg} onClick={() => toShare(coupon)}>
                        <FormattedMessage id={"share"} defaultMessage={"Share"}></FormattedMessage>
                    </span>
                    {
                        !isExpired && coupon?.willExpires &&
                        <span className={classes.ShareExpire}>
                            <FormattedMessage id="expires_soon" defaultMessage="Expires soon" />
                        </span>
                    }
                </span>
            }
            {
                /*
                !isExpired&&!isShare&&<button className={classes.ShopButton} onClick={e=>{
                    Cache.remove("__progress_coupon_id")
                    history.push(getSensorsUrl('/cart/collect-products?type=1'));
                }}><FormattedMessage id="shop" defaultMessage="shop" /></button>
                 */
                !isExpired&&!isShare&&<a className={classes.ShopA} href={"/cart/collect-products?type=1"}><FormattedMessage id="shop" defaultMessage="shop" /></a>
            }
        </div>

        <div className={classes.MeetCon}>
            {
                coupon?.willExpires&&coupon?.endDate&&
                <CountDownPart
                    date={coupon.endDate}
                />
            }
            {
                !coupon?.willExpires&&coupon?.beginDate && coupon?.endDate && <p className={classes.Desc1}>
                    <span className={classes.Dot}>.</span>
                    <span>{moment(coupon?.beginDate).format('DD/MM/YYYY HH:mm')}~{moment(coupon?.endDate).format('DD/MM/YYYY HH:mm')}</span>
                </p>
            }

            {/* {
                coupon?.usageReminder && <p className={classes.Desc2}>
                    <span className={classes.Dot}>.</span>
                    <span>{coupon.usageReminder}</span>
                </p>
            } */}
        </div>

        {
            coupon?.willExpires&&<span className={classes.ExpiresSoon}><FormattedMessage id="expires_soon" defaultMessage="Expires soon" /></span>

        }
    </div>
}

export const RedeemCouponItem = props =>{
    const { coupon, redeemCoupon, redeemTxt } = props;
    useStyles(classes)
    const Intl = useIntl()

    const redeemCouponEvent = () => {
        redeemCoupon(coupon)
    }

    const couponDate = useMemo(() => {
        return expireDate(coupon?.coupon?.beginDate, coupon?.coupon?.endDate)
    }, [coupon])

    return <div className={classes.RedeemCouponItem}>
                <div className={classes.Top}>
                    <div className={classes.Left}>
                        <p className={classes.Name}>{couponName(coupon?.coupon?.name)}</p>
                        <p className={classes.Description} style={{ marginTop: 5 }}>{coupon?.coupon?.condition || coupon?.coupon?.description || coupon?.coupon?.infoMsg}</p>
                    </div>

                    <div className={classes.Right}>
                        {`${coupon?.points} ${Intl.formatMessage({id:'points', defaultMessage:'points'})}`}
                    </div>
                </div>

                <div className={classes.Bottom}>
                    <ul className={classes.Left}>
                        {
                            couponDate ?
                            <li>
                                <span className={classes.Dot}>.</span>
                                <span className={classes.CouponDate}>{couponDate}</span>
                            </li>:
                            <React.Fragment></React.Fragment>
                        }

                        {
                            coupon?.coupon?.usageReminder ?
                            <li>
                                <span className={classes.Dot}>.</span>
                                <span className={classes.CouponDate}>{coupon.coupon.usageReminder}</span>
                            </li>:
                            <React.Fragment></React.Fragment>
                        }
                    </ul>

                    <div className={classes.Right}>
                        <button onClick={() => redeemCouponEvent()}>
                            {redeemTxt ? redeemTxt: Intl.formatMessage({id: 'redeem', defaultMessage:'Redeem'})}
                        </button>
                    </div>
                </div>

                {
                    !redeemTxt && coupon?.status == 1 ?
                    <React.Fragment>
                        <div className={classes.Redeemed}>{Intl.formatMessage({id: 'redeemed', defaultMessage:'Redeemed'})}</div>
                        <div className={classes.RedeemedBg}></div>
                    </React.Fragment>:
                    <React.Fragment></React.Fragment>
                }
            </div>
}


export const CouponList = withList(props => {
    useStyles(classes)
    const {showType, list, loading, finished, getData, showRedeemCoupon, toRedeem, redeemCoupon, toShare,showExpiringType } = props
    const couponList = useRef()
    let finalList=list
    if(showType=="unused"){
        if(showExpiringType=="expiring"){
            finalList = list?.filter(e => e.coupon?.willExpires||e.willExpires);
            if (!finalList) {
                finalList=[]
            }
        }
    }
    return (
        <div className={classes.CouponList} ref={couponList}>
            {
                showType == 'expired' ?
                <div className={classes.CouponTip}>
                    <FormattedMessage id="expired_coupon_remove" defaultMessage={'Expired coupons will be removed from the coupon pocket after 7 days.'}/>
                </div>:
                <React.Fragment>
                    {
                        showRedeemCoupon && showType == 'unused' ?
                        <div className={classes.CouponRedeemTip} onClick={() => toRedeem()}>
                            <Iconfont className={classes.CouponRedeemIcon}>&#xe6ca;</Iconfont>
                            <div className={classes.CouponRedeemMsg}>
                                <FormattedMessage id="use_points_to_redeem" defaultMessage={'Use points to redeem more coupons!'}/>
                            </div>
                            <Iconfont className={classes.CouponRedeemIcon}>&#xe694;</Iconfont>
                        </div>:
                        <React.Fragment></React.Fragment>
                    }
                </React.Fragment>
            }

            {
                finalList?.map((item, index) => {
                    return showType == 'redeem' ?
                    <RedeemCouponItem coupon={item} key={item?.id + index} redeemCoupon={redeemCoupon}/>:
                    <CouponItem coupon={item?.coupon || item} key={item?.id + index} isExpired={showType == 'expired'} isShare={item?.giftCard} toShare={toShare}/>
                })
            }
            {/* {
                !list || list?.length == 0 ?
                <div className={classes.NoMore}>
                    <FormattedMessage id="no_more_data" defaultMessage={'No more data'}/>
                </div>:
                <React.Fragment></React.Fragment>
            } */}
        </div>
    )
})